import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import FormPicker from "./pages/forms/FormPicker";
import ArtistForm from "./pages/forms/artist";
import IndustryForm from "./pages/forms/industry";
import PartnerForm from "./pages/forms/partner";
import NetworkForm from "./pages/forms/network";
import ReferralForm from "./pages/forms/referral";
import { ControlLayout } from "./pages/Control";
import LeadsList from "./pages/Control";
import LeadDetail from "./pages/LeadDetail";
import Catalog from "./pages/Catalog";
import NotionSettings from "./pages/NotionSettings";
import Partners from "./pages/Partners";
import PartnerDetail from "./pages/PartnerDetail";
import { NetworkList, NetworkDetail } from "./pages/NetworkApps";
import { InquiryList, InquiryDetail } from "./pages/Inquiries";
import { captureAttribution } from "./lib/attribution";

// Every old public link now lands on the single contact form, query string intact.
const KeepQuery = ({ to }) => {
  const { search } = useLocation();
  return <Navigate to={`${to}${search}`} replace />;
};

const Attribution = () => {
  const { pathname } = useLocation();
  useEffect(() => { captureAttribution(); }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Attribution />
        <Routes>
          <Route path="/" element={<ArtistForm />} />
          <Route path="/choose" element={<FormPicker />} />
          <Route path="/artist" element={<ArtistForm />} />
          <Route path="/industry" element={<IndustryForm />} />
          <Route path="/partner" element={<PartnerForm />} />
          <Route path="/network" element={<NetworkForm />} />
          <Route path="/referral" element={<ReferralForm />} />
          <Route path="/referralmoney" element={<KeepQuery to="/referral" />} />
          <Route path="/contact" element={<KeepQuery to="/choose" />} />
          <Route path="/join" element={<KeepQuery to="/network" />} />
          <Route path="/join/*" element={<KeepQuery to="/network" />} />
          <Route path="/apply" element={<KeepQuery to="/artist" />} />
          <Route path="/intake" element={<KeepQuery to="/artist" />} />
          <Route path="/partners/apply" element={<KeepQuery to="/partner" />} />
          <Route path="/control" element={<ControlLayout />}>
            <Route index element={<InquiryList />} />
            <Route path="inquiries" element={<InquiryList />} />
            <Route path="inquiries/:id" element={<InquiryDetail />} />
            <Route path="leads" element={<LeadsList />} />
            <Route path="leads/:id" element={<LeadDetail />} />
            <Route path="providers" element={<Partners />} />
            <Route path="providers/:id" element={<PartnerDetail />} />
            <Route path="partner-orgs" element={<NetworkList role="partner" />} />
            <Route path="partner-orgs/:id" element={<NetworkDetail role="partner" />} />
            <Route path="volunteers" element={<NetworkList role="volunteer" />} />
            <Route path="volunteers/:id" element={<NetworkDetail role="volunteer" />} />
            <Route path="labels" element={<NetworkList role="record-label" />} />
            <Route path="labels/:id" element={<NetworkDetail role="record-label" />} />
            <Route path="catalog" element={<Catalog />} />
            <Route path="notion" element={<NotionSettings />} />
          </Route>
          <Route path="*" element={<KeepQuery to="/" />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}

export default App;
